import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {DatatableDataComponent} from "./datatable-data.component";
import {ContentModule} from "../../../../shared/directives/content.module";
import {PaginationModule} from "../pagination/pagination.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        LoadingModule,
        ContentModule,
        PaginationModule,
    ],
    exports: [
        DatatableDataComponent,
        ContentModule
    ],
    declarations: [
        DatatableDataComponent,
    ]
})
export class DatatableDataModule {
}